import { freeze_rate_path } from '@routes';

import request from './request';

export interface FreezeRateResponse {
  redirectUri: string;
  success: boolean;
}

export async function freezeRate() {
  const resp = await request('post', freeze_rate_path());
  return resp;
}
